import environment from "@/modules/environment";

const { envMode } = environment;
const cameritoUrl = "camerito.com";

export default function getCameritoWebUrl() {
  const prefix = envMode === "test" ? "test." : "";
  const url = `https://${prefix}${cameritoUrl}`;

  return url;
}
